"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IceBlastAbilityHandler = exports.IceBlastActorAbilityFactory = exports.IceBlastAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Random_1 = require("../../utils/Random");
const core_2 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class IceBlastAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.IceBlast;
        this.__typeName = "IceBlast";
    }
}
exports.IceBlastAbilityArgs = IceBlastAbilityArgs;
let IceBlastActorAbilityFactory = class IceBlastActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("IceBlast", "AllEnemies", 3);
    }
};
IceBlastActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("IceBlast")
], IceBlastActorAbilityFactory);
exports.IceBlastActorAbilityFactory = IceBlastActorAbilityFactory;
let IceBlastAbilityHandler = class IceBlastAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                path: "line",
                type: "DarkBlueToVeryLightBlueLargeBolt",
                jitter: (0, Random_1.random)(50, 500),
                start: "head",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Frost", 70)
                ],
            })),
            onHit(sequence, attack, damage, { targetId }) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest"), "BlueCircles"));
                container.applyDebuffs({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    effects: [
                        {
                            duration: Duration_1.Duration.Permanent,
                            effect: new core_2.FrostyEffectArgs(),
                        },
                        {
                            duration: Duration_1.Duration.Turns(4),
                            effect: new core_2.ChillEffectArgs("Focus", 10),
                        },
                    ]
                });
            }
        });
    }
};
IceBlastAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.IceBlast)
], IceBlastAbilityHandler);
exports.IceBlastAbilityHandler = IceBlastAbilityHandler;
